import type { UserB2bDoc } from "@/Modules/Models/Domain/User";
import type { UserB2bDocsApi } from "@/Modules/Models/Api/User";

import { getUserB2bDocs } from "@/Services/TherapyApi/Users";

import useUserStore from "@/Modules/User/Store";

import { danger } from "@/Utils/Debug";

async function getB2bDocsAH() {
  const userStore = useUserStore();

  try {
    const userB2bDocsApi = await getUserB2bDocs();

    userStore.userB2bDocs = transform(userB2bDocsApi);
  } catch (e) {
    danger(e);
  }
}

function transform(userB2bDocsApi: UserB2bDocsApi[]): UserB2bDoc[] {
  return userB2bDocsApi.map((doc) => {
    return {
      uuid: doc.uuid,
      text: doc.text,
      link: doc.link,
      checked: false,
      clicked: false,
    };
  });
}

export default getB2bDocsAH;
